var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3.5 9.084c0-2.593 0-3.89.806-4.695.805-.806 2.102-.806 4.694-.806h2.75c2.592 0 3.89 0 4.694.806.806.805.806 2.102.806 4.695v4.583c0 2.592 0 3.89-.806 4.694-.805.806-2.102.806-4.694.806H9c-2.592 0-3.89 0-4.694-.806-.806-.805-.806-2.102-.806-4.694z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3.5 16.417a2.75 2.75 0 0 1-2.75-2.75v-5.5c0-3.457 0-5.186 1.074-6.26S4.627.834 8.084.834h3.666a2.75 2.75 0 0 1 2.75 2.75"
  })));
};
export default SvgCopy;